import React, { useCallback } from 'react'
import { useHistory } from 'react-router-dom'
import block from 'bem-cn'

import { ROUTE_URLS } from 'router/routes'

import SpinIconSVG from './img/spin-icon.svg'

import './WheelButton.scss'

const b = block('wheel-button')

interface IWheelButton {
  onCloseProfileMenu?: () => void
}

export const WheelButton: React.FC<IWheelButton> = ({ onCloseProfileMenu }) => {
  const history = useHistory()

  const onRouletteIconClick = useCallback(() => {
    history.push(ROUTE_URLS.WHEEL_GAME())
    if (onCloseProfileMenu) {
      onCloseProfileMenu()
    }
  }, [history, onCloseProfileMenu])

  return <img src={SpinIconSVG} alt="spin-icon" onClick={onRouletteIconClick} className={b()} />
}
